module.exports = __webpack_public_path__ + "img/ca30be0bfc901f6e1cd361671d3c2504.svg";